<div *ngIf="isLoading" class="loader-container">
  <mat-spinner color="primary"></mat-spinner>
</div>
